import { type HUImage } from "@modules/types/imageTypes"
import { type SlotSubscriberDto } from "@/modules/profile/subscriber/gateway/slotSubscriberDto"
import { convertImageFromDto } from "@/modules/dtos/imageDto"

export class SlotSubscriberEntity {
  memberId: string
  userId: string | null
  firstname: string
  lastname: string
  username: string | null
  avatar?: HUImage
  absent: boolean
  isBirthday: boolean
  isTrial: boolean | null
  isDropIn: boolean | null
  internalNote: string | null

  private constructor(slotSubscriber: SlotSubscriberEntity) {
    this.memberId = slotSubscriber.memberId
    this.userId = slotSubscriber.userId
    this.firstname = slotSubscriber.firstname
    this.lastname = slotSubscriber.lastname
    this.username = slotSubscriber.username
    this.avatar = slotSubscriber.avatar
    this.absent = slotSubscriber.absent
    this.isBirthday = slotSubscriber.isBirthday
    this.isTrial = slotSubscriber.isTrial
    this.isDropIn = slotSubscriber.isDropIn
    this.internalNote = slotSubscriber.internalNote
  }

  static fromDto(dto: SlotSubscriberDto): SlotSubscriberEntity {
    return new SlotSubscriberEntity({
      memberId: dto.memberId,
      userId: dto.userId,
      firstname: dto.firstname,
      lastname: dto.lastname,
      username: dto.username,
      avatar: dto.avatar ? convertImageFromDto(dto.avatar) : undefined,
      absent: dto.absent,
      isBirthday: dto.isBirthday,
      isTrial: dto.isTrial,
      isDropIn: dto.isDropIn,
      internalNote: dto.internalNote,
    })
  }
}
